import React from 'react';
import TextAvatar from '../Common/TextAvatar';

const ProfileInfoItem = ({ iconClass, label, value, valueFallback = "N/A", iconColorClass }) => {
  return (
    <div className="col-6 mb-3 d-flex align-items-center">
      <i className={`fa ${iconClass} ${iconColorClass} mr-3`}></i>
      <div className="text-left">
        <strong>{label}</strong>
        <p className="mb-0 text-muted">{value || valueFallback}</p>
      </div>
    </div>
  );
};

const StaffProfileInfo = ({ profileInfo }) => {
  return (
    <div>
      <TextAvatar
        text={profileInfo?.initials}
        bgClass="secondary"
        image={profileInfo?.image}
        size="120px"
      />
      <h5 className="card-title mb-1">{profileInfo.hname}</h5>
      <p className="text-muted mb-3">
            {profileInfo.status_name}
            {profileInfo.status === "1" && (
            <i className="fa fa-circle-check text-success ml-1"></i>
            )}
        </p>

      <div className="row">
        <ProfileInfoItem
          iconClass="fa-id-badge"
          iconColorClass="text-primary"
          label="Reg No"
          value={profileInfo.reg_no}
        />
        <ProfileInfoItem
          iconClass="fa-user"
          iconColorClass="text-dark"
          label="First Name"
          value={profileInfo.first_name}
        />
        <ProfileInfoItem
          iconClass="fa-user"
          iconColorClass="text-dark"
          label="Last Name"
          value={profileInfo.last_name}
        />
        <ProfileInfoItem
          iconClass="fa-venus-mars"
          iconColorClass="text-success"
          label="Gender"
          value={profileInfo.gender}
        />
        <ProfileInfoItem
          iconClass="fa-phone"
          iconColorClass="text-primary"
          label="Work Contact"
          value={profileInfo.work_contact}
        />
        <ProfileInfoItem
          iconClass="fa-phone"
          iconColorClass="text-secondary"
          label="Home Contact"
          value={profileInfo.home_contact}
        />
        <ProfileInfoItem
          iconClass="fa-envelope"
          iconColorClass="text-warning"
          label="Email"
          value={profileInfo.email}
        />
        <ProfileInfoItem
          iconClass="fa-heart"
          iconColorClass="text-danger"
          label="Marital Status"
          value={profileInfo.marital_status?.status || "N/A"}
        />
        <ProfileInfoItem
          iconClass="fa-calendar"
          iconColorClass="text-info"
          label="Birthday"
          value={profileInfo.birthday}
        />
        <ProfileInfoItem
          iconClass="fa-calendar-check"
          iconColorClass="text-success"
          label="Registration Date"
          value={profileInfo.registration_date}
        />
      </div>
    </div>
  );
};

export default StaffProfileInfo;
